import apiClient from "./client";

/**
 * A prévia do PDF do cliente (#1772): o mesmo PDF da rota da #1771, pedido em modo
 * prévia (não conta como geração no log), com o número de páginas que a rota diz
 * no cabeçalho `X-Page-Count`.
 *
 * `indexes: null` manda a lista como `sections=a&sections=b`, que é o que o
 * FastAPI lê; o padrão do axios (`sections[]=a`) seria recusado.
 */
export async function fetchClientPdfPreview(
  projectId: string,
  sections: readonly string[],
  signal: AbortSignal,
): Promise<{ blob: Blob; pages: number }> {
  const res = await apiClient.get<Blob>(`/api/projects/${projectId}/diagnostic/client-pdf`, {
    params: { preview: true, sections },
    paramsSerializer: { indexes: null },
    responseType: "blob",
    timeout: 120_000,
    signal,
  });
  return { blob: res.data, pages: Number(res.headers["x-page-count"]) };
}
